<br />
<mat-grid-list cols="1" rowHeight="35px">
  <mat-grid-tile rowspan="1">
    <h1 class="title">Permisos Controles</h1>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <button mat-raised-button color="accent" name="new" (click)="openCreate()" appPermissionControl="P094B0001"><mat-icon class="icon">add</mat-icon>Nuevo</button>
  </mat-grid-tile>
  <mat-grid-tile rowspan="2">
    <mat-form-field color="accent" appearance="outline">
      <mat-label>Buscar</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Ej. Tasa" #input appPermissionControl="P094K0001" />
      <mat-icon matSuffix color="accent">search</mat-icon>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<div id="div" class="mat-elevation-z8 table-responsive">
  <table mat-table [dataSource]="dataSource" matSort appPermissionControl="P094T0001">
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P094C0001"></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu" appPermissionControl="P094B0002">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button (click)="openUpdate(element)" mat-menu-item appPermissionControl="P094B0003">
            <mat-icon>edit</mat-icon>
            <span>Editar</span>
          </button>
          <button (click)="delete(element)" mat-menu-item appPermissionControl="P094B0004">
            <mat-icon>delete</mat-icon>
            <span>Eliminar</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>
    <ng-container matColumnDef="permissionControlId">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P094C0002">No.</th>
      <td mat-cell *matCellDef="let element">{{ element.permissionControlId }}</td>
    </ng-container>
    <ng-container matColumnDef="controlName">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P094C0003">Control</th>
      <td mat-cell *matCellDef="let element">{{ element.controlName }}</td>
    </ng-container>
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P094C0004">Rol</th>
      <td mat-cell *matCellDef="let element">{{ element.description }}</td>
    </ng-container>
    <ng-container matColumnDef="formName">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P094C0005">Formulario</th>
      <td mat-cell *matCellDef="let element">{{ element.formName }}</td>
    </ng-container>
    <ng-container matColumnDef="enable">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P094C0006">Habilitado</th>
      <td mat-cell *matCellDef="let element" [value]="element.enable">{{ element.enable ? 'Si' : 'No' }}</td>
    </ng-container>
    <ng-container matColumnDef="userCreator">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P094C0007">Usuario Creador</th>
      <td mat-cell *matCellDef="let element">{{ element.userCreator }}</td>
    </ng-container>
    <ng-container matColumnDef="visible">
      <th mat-header-cell *matHeaderCellDef appPermissionControl="P094C0008">Visible</th>
      <td mat-cell *matCellDef="let element">{{ element.visible ? 'Si' : 'No' }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20, 40, 80]" showFirstLastButtons class="paginatorTb"></mat-paginator>
</div>
